<svg class="spinner" viewBox="0 0 44 44">
    <circle class="spinner-circle" cx="22" cy="22" r="20"></circle>
</svg>
